import React from "react";
import { Compass } from "lucide-react";
import { Header } from "@/components/MobileShell";

/* Discover feed arrives in Milestone 2 — shown as a calm, honest placeholder for the private beta. */
export default function DiscoverPage() {
  return (
    <>
      <Header title="Discover" subtitle="Explore intentionally" />
      <div className="px-7 pt-20 flex flex-col items-center text-center" data-testid="discover-placeholder">
        <div className="h-16 w-16 rounded-full bg-[#F1EEE7] flex items-center justify-center">
          <Compass className="h-7 w-7 text-[#253B35]" strokeWidth={1.5} />
        </div>
        <h2 className="font-serif text-2xl text-[#1F2B26] mt-6">Your feed is being prepared</h2>
        <p className="font-sans text-sm text-[#5F6D66] leading-relaxed mt-3 max-w-xs">
          Your profile is published. The calm, scrollable Discover feed — with real profiles, saving, and connection requests — arrives in the next milestone. No swiping, ever.
        </p>
      </div>
    </>
  );
}
